import React, { useState, useEffect } from "react";
import AdminDrawer from "../../components/AdminDrawer";
import Navbar from "../../components/Navbar";
import {
  Grid,
  Typography,
  Button,
  Stack,
  Modal,
  TextField,
  Box,
} from "@mui/material";
import GeneralSkeletons from "../../components/GeneralSkeletons";
import {
  getAllAdmins,
  updateAdmin,
  deleteAdmin,
  signUpAdmin,
} from "../../apis";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

const style = {
  position: "absolute",
  top: "25%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "white",
  p: 4,
};

const AdminManager = () => {
  const [open, setOpen] = useState(false);
  const [updateOpen, setUpdateOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [adminsData, setAdminsData] = useState([]);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const response = await getAllAdmins();
      setAdminsData(response.data.admins);
      setLoading(false);
    };
    fetchData();
  }, []);

  const handleClose = () => setOpen(false);
  const handleUpdateClose = () => setUpdateOpen(false);

  const addAdminHandler = async () => {
    if (fullName == "" || email == "" || password == "") {
      setError(true);

      setErrorMessage("Please fill all of the required information.");
    } else {
      const response = await signUpAdmin({
        fullName: fullName,
        email: email,
        password: password,
      });
      if (
        response.data.success == false &&
        response.data.message == "Admin already exist with this email!"
      ) {
        setError(true);
        setErrorMessage("Admin already exist with this email!");
      }
      if (response.data.success == true) {
        setError(false);
        setOpen(false);
        const result = await getAllAdmins();
        setAdminsData(result.data.admins);
      }
    }
  };

  const clickhandler = (id) => {
    const filteredResult = adminsData.filter((item) => item._id == id);
    setSelectedAdmin(filteredResult[0]);
    setFullName(filteredResult[0].fullName);
    setEmail(filteredResult[0].email);
    setPassword(filteredResult[0].password);
    setUpdateOpen(true);
    setError(false);
  };

  const updateClickHandler = async () => {
    if (fullName == "" || email == "" || password == "") {
      setError(true);
      setErrorMessage("Please fill all of the required fields.");
    } else {
      setError(false);

      const response = await updateAdmin({
        id: selectedAdmin._id,
        email: email,
        fullName: fullName,
        password: password,
      });
      if (response.data.message == "admin updated successfully") {
        setUpdateOpen(false);
        const result = await getAllAdmins();
        setAdminsData(result.data.admins);
      }
      if (response.data.message == "admin already exist with the email") {
        setError(true);
        setErrorMessage("admin already exist with the email");
      }
    }
  };

  const deleteClickHandler = async () => {
    const response = await deleteAdmin({
      id: selectedAdmin._id,
    });
    if (response.data.deleted == true) {
      setUpdateOpen(false);
      setError(false);
      const result = await getAllAdmins();
      setAdminsData(result.data.admins);
    }
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Stack spacing={2}>
            {error ? (
              <Stack>
                <Typography style={{ color: "red" }}>{errorMessage}</Typography>
              </Stack>
            ) : (
              <></>
            )}
            <Stack>
              <Typography style={{ fontWeight: "bold" }}>Add Admin</Typography>
            </Stack>
            <Stack>
              <Typography>Full Name</Typography>
              <TextField
                size="small"
                id="outlined-basic"
                placeholder="Enter Full Name"
                variant="outlined"
                className="w-100 mt-5"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
              />
            </Stack>
            <Stack>
              <Typography>Email</Typography>
              <TextField
                size="small"
                id="outlined-basic"
                placeholder="Enter Email"
                variant="outlined"
                className="w-100 mt-5"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Stack>
            <Stack>
              <Typography>Password</Typography>
              <TextField
                size="small"
                id="outlined-basic"
                placeholder="Enter"
                variant="outlined"
                className="w-100 mt-5"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Stack>

            <Stack direction="row" justifyContent="flex-end" spacing={2}>
              <Button
                variant="outlined"
                className="default-color default-border"
                style={{ textTransform: "capitalize" }}
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                className="primary-button"
                style={{ textTransform: "capitalize" }}
                onClick={addAdminHandler}
              >
                Add
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>

      <Modal
        open={updateOpen}
        onClose={handleUpdateClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Stack spacing={2}>
            {error ? (
              <Stack>
                <Typography style={{ color: "red" }}>{errorMessage}</Typography>
              </Stack>
            ) : (
              <></>
            )}
            <Stack direction="row" justifyContent="space-between">
              <Typography style={{ fontWeight: "bold" }}>
                Update Admin
              </Typography>
              <DeleteOutlineOutlinedIcon
                onClick={deleteClickHandler}
                style={{ cursor: "pointer" }}
              />
            </Stack>
            <Stack>
              <Typography>Full Name</Typography>
              <TextField
                size="small"
                id="outlined-basic"
                placeholder="Enter Full Name"
                variant="outlined"
                className="w-100 mt-5"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
              />
            </Stack>
            <Stack>
              <Typography>Email</Typography>
              <TextField
                size="small"
                id="outlined-basic"
                placeholder="Enter Email"
                variant="outlined"
                className="w-100 mt-5"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Stack>
            <Stack>
              <Typography>Password</Typography>
              <TextField
                size="small"
                id="outlined-basic"
                placeholder="Enter"
                variant="outlined"
                className="w-100 mt-5"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Stack>

            <Stack direction="row" justifyContent="flex-end" spacing={2}>
              <Button
                variant="outlined"
                className="default-color default-border"
                style={{ textTransform: "capitalize" }}
                onClick={handleUpdateClose}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                className="primary-button"
                style={{ textTransform: "capitalize" }}
                onClick={updateClickHandler}
              >
                Update
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>

      <Navbar />
      <div className="ml-16">
        <Grid container rowSpacing={2} columnSpacing={4} className="mt-10">
          <Grid item xs={2}>
            <AdminDrawer page="Admin Manager" />
          </Grid>
          <Grid item xs={10}>
            <Grid container>
              <Grid item sm={9}>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  className="mb-16"
                >
                  <Typography variant="h6">Admin Manager</Typography>
                  <Button
                    className="primary-button"
                    variant="contained"
                    style={{ textTransform: "capitalize" }}
                    onClick={() => {
                      setOpen(true);
                      setFullName("");
                      setEmail([]);
                      setPassword("");
                      setError(false);
                    }}
                  >
                    Add New
                  </Button>
                </Stack>
                <div
                  style={{ border: "1px solid #EEEBEF", borderRadius: "6px" }}
                  className="mb-16"
                >
                  <Stack spacing={2}>
                    {adminsData.length && loading == false ? (
                      adminsData.map((item) => (
                        <div
                          style={{
                            borderBottom: "1px solid #EEEBEF",
                            marginTop: "20px",
                            paddingBottom: "20px",
                            paddingLeft: "20px",
                            cursor: "pointer",
                          }}
                          onClick={() => clickhandler(item._id)}
                        >
                          <Typography
                            style={{
                              fontWeight: "bold",
                              textTransform: "capitalize",
                            }}
                          >
                            {item.fullName}
                          </Typography>
                          <Typography>{item.email}</Typography>
                        </div>
                      ))
                    ) : adminsData.length == 0 && loading == false ? (
                      <>
                        <Typography>No Admins Found</Typography>
                      </>
                    ) : (
                      <>
                        <GeneralSkeletons />
                        <GeneralSkeletons />
                        <GeneralSkeletons />
                        <GeneralSkeletons />
                        <GeneralSkeletons />
                      </>
                    )}
                  </Stack>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default AdminManager;
